import React from 'react';
import i18n from 'i18next';
import { useLanguage } from 'react-lib/dist/hooks-es';
import { ChooseLanguage } from 'react-lib/dist/components-es';
import Connector from '../../agent';

const { api } = Connector;

const ChooseLanguageWrapper = () => {
  const [, setLang] = useLanguage(api, i18n);

  return <ChooseLanguage language={i18n.language} updateLanguage={setLang} />;
};

export default ChooseLanguageWrapper;
